import { render, staticRenderFns } from "./AdminIpDatatable.vue?vue&type=template&id=6677fdb6&"
import script from "./AdminIpDatatable.vue?vue&type=script&lang=js&"
export * from "./AdminIpDatatable.vue?vue&type=script&lang=js&"
import style0 from "./AdminIpDatatable.vue?vue&type=style&index=0&id=6677fdb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports